import { pdf, type DocumentProps } from '@react-pdf/renderer';
import { createElement, type ReactElement } from 'react';
import type { Question, Recommendation } from '../data/schemas';
import type { TestResult } from '../types/result';
import { ResultPdfDocument } from './ResultPdfDocument';

interface GenerateResultPdfOptions {
  result: TestResult;
  recommendations: readonly Recommendation[];
  questions: readonly Question[];
  maximumFeaturedTensions: number;
  showClusterDetailSection: boolean;
  showWeightingDetails: boolean;
}

/** Erzeugt den PDF-Ergebnisbericht mit echtem Text und löst den Download im Browser aus. */
export async function downloadResultPdf(options: GenerateResultPdfOptions): Promise<void> {
  // ResultPdfDocument rendert zur Laufzeit ein <Document>; @react-pdf/renderer typisiert
  // pdf() aber nur direkt gegen ReactElement<DocumentProps>, daher der gezielte Cast.
  const document = createElement(ResultPdfDocument, options) as ReactElement<DocumentProps>;
  const blob = await pdf(document).toBlob();
  const url = URL.createObjectURL(blob);

  const link = window.document.createElement('a');
  link.href = url;
  link.download = 'passt-instagram-als-sichtbarkeitskanal-ergebnis.pdf';
  window.document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
